"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.settings.general': 'General',
    'route.settings.styles': 'Estilos',
    'route.settings.access': 'Accesos',
    'route.settings.accessEdit': 'Editar Acceso',
    'route.settings.accessAdd': 'Agregar Acceso',
    'route.settings.socialMediaPlan': 'Marcas y Equipo',
    'route.settings.whatsapp': 'WhatsApp',
    'route.settings.whatsapp.manage': 'Gestionar número de WhatsApp',
    'route.settings.whatsappSettings': 'Números de WhatsApp',
    'route.settings.whatsappSettings.create': 'Añadir número de WhatsApp',
    'route.settings.whatsappSettings.edit': 'Editar número de WhatsApp',
};
